import React, { useMemo } from "react"

import "./heatMap.scss"
import type { CourtField } from "@/constants/sportConfig"

const BACKGROUND_IMAGE_URL = "/images/verticalGround.svg"

export interface PointData {
  x: number
  y: number
  value: number
}

export default function HeatMap({
  data,
  color,
  width,
  height,
  maxValue,
  backgroundSvg = BACKGROUND_IMAGE_URL,
  courtField = { left: 0, top: 0, right: 1, bottom: 1 },
}: {
  data: PointData[]
  color: string
  width: number
  height: number
  maxValue: number
  backgroundSvg?: string
  // 이미지 안 실제 경기장 영역(0~1). 기본 full-bleed = 기존(4.833/5.625) 동작.
  courtField?: CourtField
}) {
  // 96×72 그리드를 경기장 영역에 맞춰 배치 (full-bleed면 348/72=4.833, 540/96=5.625와 동일)
  const fieldLeft = courtField.left * width
  const fieldTop = courtField.top * height
  const cellW = ((courtField.right - courtField.left) * width) / 72
  const cellH = ((courtField.bottom - courtField.top) * height) / 96

  const processedData = useMemo(() => {
    return data.map((point) => ({
      ...point,
      opacity: (point.value / maxValue) * 10,
    }))
  }, [data])

  const renderPoint = (point: any, index: number) => {
    return (
      <div
        key={index}
        className="heat-point"
        style={{
          left: `${fieldLeft + point.y * cellW}px`,
          top: `${fieldTop + point.x * cellH}px`,
          backgroundColor: color,
          opacity: point.opacity,
        }}
      />
    )
  }

  return (
    <div className="HeatMap" style={{ width }}>
      <div className="HeatMapContainer" style={{ width: width + "px", height: height + "px" }}>
        <img className="heat-map-background" src={backgroundSvg} alt="BACKGROUND_IMAGE_URL" />
        <div className="heat-map-points">
          {processedData.map((point, index) => renderPoint(point, index))}
        </div>
      </div>
    </div>
  )
}
